export default __webpack_public_path__ + "static/media/lesson2.d69ba512.svg";